import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { debounce, map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import moment from "moment"
import { deleteMember, getUsers } from "store/actions"
import UserModal from "./Crud/Modal"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { useRole, getRoleLabel } from "hooks/useRole"

const Members = ({ staffType }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [userModal, setUserModal] = useState({ status: false, data: {} })
  const [totalListLimit, setTotalListLimit] = useState("10")
  const [searchText, setSearchText] = useState("")
  const [sortValues, setSortValues] = useState("member")

  const { isSuperAdmin } = useRole()
  const { branchId } = useGetBranchDetails()

  const { loading, allUser } = useSelector(state => ({
    loading: state.Members?.loading,
    allUser: state.Members.users,
  }))

  const totalPages = Math.ceil(allUser?.total / 10)
  const pages = range(1, totalPages + 1)

  const sort = sortValues

  useEffect(() => {
    if (isSuperAdmin()) {
      dispatch(
        getUsers(
          page,
          totalListLimit,
          searchText,
          "",
          sort,
          branchId,
          staffType
        )
      )
    } else {
      dispatch(getUsers(page, totalListLimit, searchText, "", sort, branchId))
    }
  }, [dispatch, page, totalListLimit, searchText, sort, branchId, staffType])

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteMember(isOpen?.id))
  }

  const columns = [
    {
      dataField: "id",
      text: "#",
    },

    {
      dataField: "createdAt",
      text: "Joined on",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      dataField: "email",
      text: "E-mail",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
      formatter: (cell, row) => (
        <span>
          {row?.countryCode || "+91"} {row?.phone || "----"}
        </span>
      ),
    },
    {
      dataField: "memberRole",
      text: "Designation",
      sort: true,
    },

    {
      dataField: "action",
      text: "Action",
    },
  ]

  const debounceUserSearch = debounce(value => setSearchText(value), 600)

  const handlePageLimit = e => {
    setTotalListLimit(e)
  }

  const listChange = sortValue => {
    setSortValues(sortValue)
    history?.push({
      pathname: location.pathname,
      search: `p=${page}&s=${sortValue}`,
      state: {
        page: page,
        sort: sortValue,
      },
    })
  }

  const handleRoleFormatted = role => {
    return getRoleLabel(role)
  }

  const tableData = map(allUser?.users, (item, index) => ({
    ...item,
    id: index + 1,
    memberRole: (
      <span style={{ textTransform: "capitalize" }}>
        {handleRoleFormatted(item?.memberRole)}
      </span>
    ),
    email: <div style={{ whiteSpace: "break-spaces" }}>{item?.email}</div>,
    createdAt: moment(item.createdAt).format("DD/MM/YYYY - h:mm a"),
    action: (
      <div>
        <Link
          to={`#`}
          className="btn-md"
          onClick={() => setUserModal({ status: true, data: item })}
        >
          <i className="bx bx-edit me-2 " style={{ fontSize: "1.3rem" }} />
        </Link>
        <Button
          id={`Delete${index}`}
          type="button"
          color="white"
          className="ms-1 btn"
          onClick={() => {
            handleDelete(item?._id)
          }}
        >
          <i
            className="bx bx-trash me-2"
            style={{
              color: "red",
              marginBottom: "10px",
              fontSize: "1.3rem",
            }}
          />
        </Button>
      </div>
    ),
  }))

  const optionsRoleMember = [
    { label: "All", value: "member" },
    { label: "Enquiry Manager", value: "enquiryManager" },
    { label: "Enquiry Analyst", value: "enquiryAnalyst" },
    { label: "Sales Manager", value: "salesManager" },
    { label: "Sales Executive", value: "salesExecutive" },
    { label: "Managing Director", value: "managingDirector" },
    { label: "General Manager", value: "generalManager" },
    { label: "Branch Manager", value: "branchManager" },
    { label: "Purchase Manager", value: "purchaseManager" },
    { label: "Inspection User", value: "inspectionUser" },
    {
      label: "BDE",
      value: "businessDevelopmentOfficer",
    },
    { label: "Team Member", value: "teamMember" },
  ]

  const handleRoleOptions = () => {
    if (isSuperAdmin()) {
      if (staffType === "hqStaff") {
        return [
          { label: "All", value: "member" },
          { label: "Enquiry Manager", value: "enquiryManager" },
          { label: "Enquiry Analyst", value: "enquiryAnalyst" },
          { label: "Branch Manager", value: "branchManager" },
          { label: "Purchase Manager", value: "purchaseManager" },
          {
            label: "BDE",
            value: "businessDevelopmentOfficer",
          },

          { label: "Managing Director", value: "managingDirector" },
          { label: "General Manager", value: "generalManager" },
        ]
      }
    }
    return optionsRoleMember.filter(i => i.label !== "BDE")
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        <UserModal
          onCloseClick={() => setUserModal({ status: false, data: {} })}
          show={userModal?.status}
          updateData={userModal?.data}
        />
        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={columns}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex aling-items-center justify-content-between">
                      <div className="py-2">
                        {map(handleRoleOptions(), (head, key) => (
                          <>
                            <input
                              type="radio"
                              className="btn-check"
                              name="btnradio"
                              id={key + 1}
                              autoComplete="off"
                              checked={sortValues === head.value}
                              onChange={() => listChange(head?.value)}
                            />
                            <label
                              className="btn btn-warning"
                              htmlFor={key + 1}
                              style={{
                                borderRadius: 1,
                              }}
                            >
                              {head?.label}
                            </label>
                          </>
                        ))}
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex">
                        <div>
                          {" "}
                          <div>
                            {" "}
                            <div className="search-box mb-2 d-inline-block">
                              <div className="position-relative">
                                <AvForm>
                                  <AvField
                                    name="searchText"
                                    placeholder="Search"
                                    type="text"
                                    onChange={e =>
                                      debounceUserSearch(e.target.value)
                                    }
                                  />
                                </AvForm>
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          {" "}
                          <div>
                            <AvForm className="form-horizontal mx-2 mb-3 d-flex align-items-center">
                              <div className="mx-1">
                                <span className="">
                                  Show
                                  <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                                </span>
                              </div>
                              <div className="" style={{ width: "50px" }}>
                                <AvField
                                  name="pageLimit"
                                  className="form-control"
                                  value={totalListLimit}
                                  onChange={e =>
                                    handlePageLimit(e.target.value)
                                  }
                                  type="text"
                                  required
                                />
                              </div>
                            </AvForm>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>
                          {" "}
                          <div className="">
                            <Button
                              type="button"
                              color="warning"
                              className="btn-rounded  mb-2 me-2"
                              onClick={() => setUserModal({ status: true })}
                            >
                              <i className="mdi mdi-plus me-1" />
                              Create Member
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {allUser?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                  // onTableChange={handleTableChange}
                                  // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Members !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

import PropTypes from "prop-types"
import useGetBranchDetails from "components/Common/Hooks/useGetBranchDetails"

Members.propTypes = {
  staffType: PropTypes.any,
}

export default Members
